
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import {
  IRepeaterColumn,
  IRowDataInfo,
} from 'rt/UIApiControllers/RepeaterControllers/RepeaterStructure';
import TDefaultCell from './DefaultCell.vue';

@Component({
  name: 'NumericCell',
  components: {
    TDefaultCell,
  },
})
export default class NumericCell extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  column: IRepeaterColumn;

  @Prop({
    type: Object,
    required: true,
  })
  row: IRowDataInfo;
}
